export class User {
    id: string;
    nome: string;
    perfil: string;
    codAgente: number;

    constructor() {
        this.id = '';
        this.nome = '';
        this.perfil = null;
        this.codAgente = 0;
    }
}